import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';

const CustomTimePicker = (props) => (
  <TimePicker {...props} />
)

export default CustomTimePicker